import type { SxProps, Theme } from '@mui/material/styles';

import { FIGMA_REF } from '../../../features/landing/layout';

export const topNavStyles: Record<string, SxProps<Theme>> = {
  root: (theme) => ({
    position: 'sticky',
    top: 0,
    zIndex: theme.zIndex.appBar,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    minHeight: { xs: 64, md: 88 },
    boxSizing: 'border-box',
    width: '100%',
    paddingInline: {
      xs: theme.spacing(2),
      md: `clamp(24px, 4vw, ${FIGMA_REF.nav.padInline}px)`,
    },
    paddingBlock: { xs: theme.spacing(1.5), md: 0 },
    backgroundColor: theme.palette.background.default,
    // Figma top banner carries a soft drop shadow separating it from
    // the hero below.
    boxShadow: theme.elevations.nav,
  }),
  brand: {
    display: 'inline-flex',
    alignItems: 'center',
    textDecoration: 'none',
  },
  actions: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 2,
  },
  backButton: (theme) => ({
    fontFamily: theme.typography.button.fontFamily,
    fontWeight: theme.typography.fontWeightBold,
    textTransform: 'none',
    fontSize: '1rem',
  }),
};
